/* eslint-disable no-restricted-globals */
const win = typeof window === 'undefined' ? undefined : window;
const doc = typeof document === 'undefined' ? undefined : document;

export {
    win as window,
    doc as document,
};
